// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ContactlessPaymentBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19.073 8.294a16.327 16.327 0 0 1 0 15.412 1.5 1.5 0 1 1-2.647-1.412 13.339 13.339 0 0 0 0-12.588 1.499 1.499 0 1 1 2.645-1.412h.002Zm-6.528 1.382a1.5 1.5 0 0 0-.625 2.029 9.126 9.126 0 0 1 0 8.59 1.499 1.499 0 1 0 2.648 1.41 12.124 12.124 0 0 0 0-11.41 1.5 1.5 0 0 0-2.023-.619ZM29.5 16A13.5 13.5 0 1 1 16 2.5 13.515 13.515 0 0 1 29.5 16Zm-3 0A10.5 10.5 0 1 0 16 26.5 10.511 10.511 0 0 0 26.5 16Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
